var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.06482 4.72442H3.03552C1.57061 4.72442 0.62085 3.766 0.62085 2.55113C0.62085 1.31263 1.59868 0.374298 3.0929 0.374298C4.5859 0.374298 5.50391 1.31027 5.53321 2.54759C5.53321 3.76245 4.5859 4.72442 3.06482 4.72442ZM21.3836 18.8302H16.7948V12.3422C16.7948 10.644 16.077 9.4847 14.4985 9.4847C13.2912 9.4847 12.6198 10.267 12.3073 11.021C12.2041 11.2593 12.2059 11.58 12.2078 11.9106C12.2081 11.9555 12.2084 12.0006 12.2084 12.0456V18.8302H7.66224C7.66224 18.8302 7.72083 7.33742 7.66224 6.29272H12.2084V8.26038C12.4769 7.40005 13.9296 6.17218 16.2479 6.17218C19.124 6.17218 21.3836 7.97557 21.3836 11.8589V18.8302ZM5.19141 6.29271H1.14457V18.8302H5.19141V6.29271Z",
    fill: "#0081FE",
    fillOpacity: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.b340b06d55f3b6cc694a1af8bdd1fff2.svg";
export { ForwardRef as ReactComponent };